export default __webpack_public_path__ + "static/media/1_0062.dab6086d.webp";